import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { translateBackendErrorCode } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { DEPRECATED_Typography as Typography, getImageSource, Loading, useTranslations } from "@jti/ui";
import useLoggedUser from "../../helpers/hooks/useLoggedUser";
import { PointsTrigger } from "../points-trigger/PointsTrigger";
import { ResponsiveContainer } from "../responsive-container/ResponsiveContainer";
import { ArticleRestrictedContentHeader } from "./ArticleRestrictedContentHeader/ArticleRestrictedContentHeader";
import { PreviewContent } from "./PreviewContent/PreviewContent";
import styles from "./ArticleRestrictedContent.module.scss";
export const ArticleRestrictedContent = ({ primaryBtnUrl, secondaryBtnUrl, previewContent, primaryBtnUrlRestricted, isInEditor, article, disableTiers = false, children, richTextComponent, }) => {
    const [isLogged] = useLoggedUser();
    const [isLoading, setIsLoading] = useState(false);
    const [{ hasError, errorText }, setErrorState] = useState({
        hasError: false,
        errorText: null,
    });
    const [articleData, setArticleData] = useState({
        is_available: false,
        is_read: null,
        value: null,
        levels: [],
    });
    const notRestricted = (isLogged && (articleData.is_available || disableTiers)) || isInEditor;
    const isArticleAvailable = articleData.is_available || disableTiers;
    const { __ } = useTranslations();
    const imageData = getImageSource(article.image, article.title);
    useEffect(() => {
        const getArticleData = async () => {
            if (!isInEditor && article.articleId) {
                try {
                    setIsLoading(true);
                    const user = getUser();
                    const response = (await LoyaltyApi.init().getArticles({
                        uuid: user.uuid,
                        ciam_token: user.ciam_token,
                        idsParams: [article.articleId],
                    }))[0];
                    if (response) {
                        setArticleData({
                            is_available: response.is_available,
                            is_read: response.is_read,
                            value: response.value,
                            levels: response.levels,
                        });
                    }
                }
                catch (error) {
                    console.log(error);
                    setErrorState({
                        hasError: true,
                        errorText: translateBackendErrorCode(error.error_code, __("loyalty.articleRestrictedContent.errorMessage")),
                    });
                }
                finally {
                    setIsLoading(false);
                }
            }
        };
        getArticleData();
    }, [article.articleId, isLogged, isInEditor]);
    if (hasError)
        return (_jsx(Typography, { type: "h1", className: styles.error, color: "black", children: __(errorText) }));
    return (_jsx("div", { className: styles.content, children: isLoading ? (_jsx("div", { className: styles.loading, children: _jsx(Loading, { dataTestId: "loadingarticle" }) })) : (_jsxs(_Fragment, { children: [_jsx(ArticleRestrictedContentHeader, { title: article.title, subtitle: article.subtitle, isRead: articleData.is_read, creationDate: article.creationDate, points: articleData.value, tier: articleData.levels[0], disableTiers: disableTiers, image: imageData, isAvailable: articleData.is_available }), notRestricted && (_jsxs(ResponsiveContainer, { size: "medium", children: [children, _jsx(PointsTrigger, { articleId: article.articleId, isArticleRead: articleData.is_read, setArticleData: setArticleData, isInEditor: isInEditor })] })), _jsx(PreviewContent, { primaryBtnUrl: primaryBtnUrl, secondaryBtnUrl: secondaryBtnUrl, isLogged: isLogged, previewContent: previewContent, primaryBtnUrlRestricted: primaryBtnUrlRestricted, isInEditor: isInEditor, isAvailable: isArticleAvailable, disableTiers: disableTiers, richTextComponent: richTextComponent })] })) }));
};
//# sourceMappingURL=ArticleRestrictedContent.js.map